import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmittedLayer } from '../../../../../../viewer/report/manifest';
import { InfoBox } from '../../../../info-box/info-box';

type Props = {
  omitted: OmittedLayer[];
  /** After an export, what was left out of it; before, what will be. */
  exported?: boolean;
};

function getKindText(t: TFunction, kind: string) {
  switch (kind) {
    case 'pointcloud':
      return t('cadDrawingReport.omitted.pointcloud', { ns: 'skyviewReport' });
    case 'tiledModel':
      return t('cadDrawingReport.omitted.tiledModel', { ns: 'skyviewReport' });
    case 'model':
      return t('cadDrawingReport.omitted.model', { ns: 'skyviewReport' });
    case 'drawing':
      return t('cadDrawingReport.omitted.drawing', { ns: 'skyviewReport' });
    case 'backgroundMap':
      return t('cadDrawingReport.omitted.backgroundMap', { ns: 'skyviewReport' });
    default:
      return kind;
  }
}

/**
 * Lists what is shown in the viewer but can't be in the CAD drawing report.
 */
export const CadDrawingReportOmitted = ({ omitted, exported = false }: Props) => {
  const { t } = useTranslation();

  if (omitted.length === 0) {
    return null;
  }

  return (
    <InfoBox color="yellow">
      {exported
        ? t('cadDrawingReport.omitted.exportedHeader', { ns: 'skyviewReport' })
        : t('cadDrawingReport.omitted.header', { ns: 'skyviewReport' })}
      <ul>
        {omitted.map((layer, index) => (
          <li key={index}>
            {getKindText(t, layer.kind)}
            {layer.name ? `: ${layer.name}` : ''}
          </li>
        ))}
      </ul>
    </InfoBox>
  );
};
